// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostFormBlock6-commonHeaderAdmin-J7M2X {
	position: fixed !important;
}

.WhyHostFormBlock6-adminLayout-ilo_n {
	padding-top: 64px !important;
}

.WhyHostFormBlock6-box-NJVo9 h2 {
	font-size: 21px;
	font-weight: 600;
}

.WhyHostFormBlock6-exportLink-BSVwI {
	margin-bottom: -29px;
}

.WhyHostFormBlock6-blockCenter-AbHyj {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.WhyHostFormBlock6-panelHeader-hEmsl {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.WhyHostFormBlock6-currencyselect-eLw_z {
	width: 100%;
	margin-right: 0px;
}

.WhyHostFormBlock6-panelHeader-hEmsl {
	overflow: hidden;
	position: relative;
}

.WhyHostFormBlock6-mar0-Qsqoi {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock6-blockCenter-AbHyj {
		padding: 0px;
	}

	.WhyHostFormBlock6-panelHeader-hEmsl {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.WhyHostFormBlock6-sideAdminPageWrapper-daoO5 {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.WhyHostFormBlock6-panelHeader-hEmsl {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.WhyHostFormBlock6-table-BaEfx {
	display: table;
}

.WhyHostFormBlock6-tableRow-gTTtN {
	display: table-row;
}

.WhyHostFormBlock6-tableCell-XLctl {
	display: table-cell;
	float: none;
}

.WhyHostFormBlock6-formGroup-ywIdl {
	margin-bottom: 6px;
}

.WhyHostFormBlock6-select-TIwKO {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.WhyHostFormBlock6-noMargin-Xpe8C {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.WhyHostFormBlock6-exportLink-BSVwI {
	padding-top: 10px;
	padding-right: 10px;
}

.WhyHostFormBlock6-labelTextNew-dFjxu {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock6-displayInline-Y3ItB {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.WhyHostFormBlock6-btnUPdate-HKNY6 {
	display: inline-block;
}

.WhyHostFormBlock6-btnModalDelete-WhJCw {
	display: inline-block;
	margin-left: 15px;
}

.WhyHostFormBlock6-radioBtn-MJoBJ {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.WhyHostFormBlock6-backgroundImg-JjHIs {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock6-btnUPdate-HKNY6 {
		display: block;
		margin-bottom: 12px;
	}

	.WhyHostFormBlock6-btnModalDelete-WhJCw {
		display: block;
		margin-left: 0px;
	}

	.WhyHostFormBlock6-btnWidth-nKFEw {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.WhyHostFormBlock6-bannerImageBg-soULi {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.WhyHostFormBlock6-bannerDelete-Js_wy {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.WhyHostFormBlock6-modalRoot-iUPe0 {
	padding: 32px;
}

.WhyHostFormBlock6-modalBorderBottom-A9VOA {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.WhyHostFormBlock6-logInModalBody-aAAu_ {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.WhyHostFormBlock6-exportSection-nDfPl {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.WhyHostFormBlock6-exportSectionGridSub-IJ8ZT {
	grid-template-columns: 50% 49% !important;
}

.WhyHostFormBlock6-exportText-xNU_b {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.WhyHostFormBlock6-exportLinkImg-r2tz8 {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.WhyHostFormBlock6-vtrMiddle-oHsFE {
	vertical-align: middle;
}

.WhyHostFormBlock6-exportImg-ozWHO {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.WhyHostFormBlock6-profileViewlabel-iT7Ld {
	display: inline-block;
	width: 38%
}

.WhyHostFormBlock6-profileViewMainContent-WJ9Wy {
	display: inline-block;
	width: 62%;
}

.WhyHostFormBlock6-profileViewMain-Ywe8i {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.WhyHostFormBlock6-profileViewInner-lDwg_ {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.WhyHostFormBlock6-profileImageSection-SGBjl {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.WhyHostFormBlock6-lastviewInner-il0Nf {
	padding: 10px;
}

.WhyHostFormBlock6-whyHostHoriLine-TvRkY {
	margin: 30px 0;
}

.WhyHostFormBlock6-tableGrid-j_efe {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.WhyHostFormBlock6-headingContent-umVc8 {
	font-size: 18px;
	font-weight: 500;
}

.WhyHostFormBlock6-refundTextColor-cXBo1 {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.WhyHostFormBlock6-dividerLine-nrn0m {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.WhyHostFormBlock6-smallContent-uUmTZ {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.WhyHostFormBlock6-sideAdminPageWrapper-daoO5 {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.WhyHostFormBlock6-sideAdminPageWrapper-daoO5 {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.WhyHostFormBlock6-exportSection-nDfPl {
		grid-template-columns: 100%;
	}

	.WhyHostFormBlock6-exportSectionGridSub-IJ8ZT {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock6-profileViewlabel-iT7Ld {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.WhyHostFormBlock6-profileViewMainContent-WJ9Wy {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.WhyHostFormBlock6-ChangeToUpperCase-LXtKN {
	text-transform: uppercase
}

.WhyHostFormBlock6-noBorder-zqUDB {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.WhyHostFormBlock6-siteAdminHeading-jhpFi {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock6-siteAdminSubHeading-Uvv2X {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock6-adminFormDivider-InGdX {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.WhyHostFormBlock6-errorMessage-l65Kb {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.WhyHostFormBlock6-panelHeader-hEmsl {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.WhyHostFormBlock6-formGroup-ywIdl {
  margin-bottom: 6px;
}

.WhyHostFormBlock6-select-TIwKO {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.WhyHostFormBlock6-labelText-OKeku {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.WhyHostFormBlock6-space1-S4jdU {
	margin-bottom: 6px !important;
}

.WhyHostFormBlock6-space2-YBdLM {
	margin-bottom: 12px !important;
}

.WhyHostFormBlock6-space3-VVMHo {
	margin-bottom: 18px !important;
}

.WhyHostFormBlock6-space4-D3rzv {
	margin-bottom: 24px !important;
}

.WhyHostFormBlock6-space5-JhLc5 {
	margin-bottom: 30px !important;
}

.WhyHostFormBlock6-space6-afjY1 {
	margin-bottom: 36px !important;
}

.WhyHostFormBlock6-space7-oFy5Y {
	margin-bottom: 42px !important;
}

.WhyHostFormBlock6-spaceTop8-FmQHC {
	margin-bottom: 48px !important;
}

.WhyHostFormBlock6-spaceTop1-MGGkT {
	margin-top: 6px !important;
}

.WhyHostFormBlock6-spaceTop2-boGQR {
	margin-top: 12px !important;
}

.WhyHostFormBlock6-spaceTop3-nV_iP {
	margin-top: 18px !important;
}

.WhyHostFormBlock6-spaceTop4-JFkGm {
	margin-top: 24px !important;
}

.WhyHostFormBlock6-spaceTop5-aHmVV {
	margin-top: 30px !important;
}

.WhyHostFormBlock6-spaceTop6-LMlA1 {
	margin-top: 36px !important;
}

.WhyHostFormBlock6-spaceTop7-ViejD {
	margin-top: 42px !important;
}

.WhyHostFormBlock6-spaceTop8-FmQHC {
	margin-top: 48px !important;
}

.WhyHostFormBlock6-noMargin-Xpe8C {
	margin: 0px !important;
}

.WhyHostFormBlock6-padding1-jrVou {
	padding-bottom: 6px !important;
}

.WhyHostFormBlock6-padding2-fgsui {
	padding-bottom: 12px !important;
}

.WhyHostFormBlock6-padding3-rDIV1 {
	padding-bottom: 18px !important;
}

.WhyHostFormBlock6-padding4-JswGt {
	padding-bottom: 24px !important;
}

.WhyHostFormBlock6-padding5-c90_J {
	padding-bottom: 30px !important;
}

.WhyHostFormBlock6-padding6-wSAex {
	padding-bottom: 36px !important;
}

.WhyHostFormBlock6-padding7-rhSCJ {
	padding-bottom: 42px !important;
}

.WhyHostFormBlock6-paddingTop1-u3V8G {
	padding-top: 6px !important;
}

.WhyHostFormBlock6-paddingTop2-WgwBY {
	padding-top: 12px !important;
}

.WhyHostFormBlock6-paddingTop3-qHqX5 {
	padding-top: 18px !important;
}

.WhyHostFormBlock6-paddingTop4-qo2U4 {
	padding-top: 24px !important;
}

.WhyHostFormBlock6-paddingTop5-jKYO6 {
	padding-top: 30px !important;
}

.WhyHostFormBlock6-paddingTop6-j8WBU {
	padding-top: 36px !important;
}

.WhyHostFormBlock6-paddingTop7-Rfpwd {
	padding-top: 42px !important;
}

.WhyHostFormBlock6-noPadding-B0IuZ {
	padding: 0px !important;
}

.WhyHostFormBlock6-textBold-RwOln {
	font-weight: 500 !important;
}

.WhyHostFormBlock6-textBolder-SZAT1 {
	font-weight: 700 !important;
}

.WhyHostFormBlock6-textNormal-I09uA {
	font-weight: normal !important;
}

.WhyHostFormBlock6-spaceBottom20-kSw56 {
	margin-bottom: 20px;
}

.WhyHostFormBlock6-spaceBottom10-PDHRs {
	margin-bottom: 10px;
}

.WhyHostFormBlock6-marginNone-Rz0jp {
	margin: 0;
}

.WhyHostFormBlock6-spaceBottom15-Z9cV2 {
	margin-bottom: 15px;
}

.WhyHostFormBlock6-marginTopNone-yqBVx {
	margin-top: 0;
}

.WhyHostFormBlock6-spaceTop11-cIRe2 {
	margin-top: 11px;
}

.WhyHostFormBlock6-spaceTop21-rJKoA {
	margin-top: 21px;
}

.WhyHostFormBlock6-spaceTop20-Aj1Pi {
	margin-top: 20px;
}

.WhyHostFormBlock6-spaceTop10-U3t45 {
	margin-top: 10px;
}

/*New Design Text Colors */

.WhyHostFormBlock6-textDarkBlue-weMNd {
	color: rgb(20, 39, 94) !important;
}

.WhyHostFormBlock6-textLightBlue-qXKZf {
	color: rgb(57, 87, 106) !important;
}

.WhyHostFormBlock6-textLightSandleGreen-eA7pw {
	color: rgb(76, 86, 41) !important;
}

.WhyHostFormBlock6-textLightBrown-sJZSq {
	color: rgb(115, 79, 33) !important;
}

.WhyHostFormBlock6-textMediumMaroon-svSCX {
	color: rgb(87, 37, 51) !important;
}

.WhyHostFormBlock6-textBrown-BUoMP {
	color: rgb(160, 47, 24) !important;
}

.WhyHostFormBlock6-textMaroon-IJllk {
	color: rgb(155, 49, 67) !important;
}

.WhyHostFormBlock6-textDarkBrown-sdLzl {
	color: rgb(83, 18, 16) !important;
}

.WhyHostFormBlock6-textMediumBrown-spxCb {
	color: rgb(142, 28, 10) !important;
}

.WhyHostFormBlock6-textSkyBlue-W02pi {
	color: rgb(37, 117, 141) !important;
}

.WhyHostFormBlock6-textGray-Bx_k1 {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `WhyHostFormBlock6-commonHeaderAdmin-J7M2X`,
	"adminLayout": `WhyHostFormBlock6-adminLayout-ilo_n`,
	"box": `WhyHostFormBlock6-box-NJVo9`,
	"exportLink": `WhyHostFormBlock6-exportLink-BSVwI`,
	"blockCenter": `WhyHostFormBlock6-blockCenter-AbHyj`,
	"panelHeader": `WhyHostFormBlock6-panelHeader-hEmsl`,
	"currencyselect": `WhyHostFormBlock6-currencyselect-eLw_z`,
	"mar0": `WhyHostFormBlock6-mar0-Qsqoi`,
	"sideAdminPageWrapper": `WhyHostFormBlock6-sideAdminPageWrapper-daoO5`,
	"table": `WhyHostFormBlock6-table-BaEfx`,
	"tableRow": `WhyHostFormBlock6-tableRow-gTTtN`,
	"tableCell": `WhyHostFormBlock6-tableCell-XLctl`,
	"formGroup": `WhyHostFormBlock6-formGroup-ywIdl`,
	"select": `WhyHostFormBlock6-select-TIwKO`,
	"noMargin": `WhyHostFormBlock6-noMargin-Xpe8C`,
	"labelTextNew": `WhyHostFormBlock6-labelTextNew-dFjxu`,
	"displayInline": `WhyHostFormBlock6-displayInline-Y3ItB`,
	"btnUPdate": `WhyHostFormBlock6-btnUPdate-HKNY6`,
	"btnModalDelete": `WhyHostFormBlock6-btnModalDelete-WhJCw`,
	"radioBtn": `WhyHostFormBlock6-radioBtn-MJoBJ`,
	"backgroundImg": `WhyHostFormBlock6-backgroundImg-JjHIs`,
	"btnWidth": `WhyHostFormBlock6-btnWidth-nKFEw`,
	"bannerImageBg": `WhyHostFormBlock6-bannerImageBg-soULi`,
	"bannerDelete": `WhyHostFormBlock6-bannerDelete-Js_wy`,
	"modalRoot": `WhyHostFormBlock6-modalRoot-iUPe0`,
	"modalBorderBottom": `WhyHostFormBlock6-modalBorderBottom-A9VOA`,
	"logInModalBody": `WhyHostFormBlock6-logInModalBody-aAAu_`,
	"exportSection": `WhyHostFormBlock6-exportSection-nDfPl`,
	"exportSectionGridSub": `WhyHostFormBlock6-exportSectionGridSub-IJ8ZT`,
	"exportText": `WhyHostFormBlock6-exportText-xNU_b`,
	"exportLinkImg": `WhyHostFormBlock6-exportLinkImg-r2tz8`,
	"vtrMiddle": `WhyHostFormBlock6-vtrMiddle-oHsFE`,
	"exportImg": `WhyHostFormBlock6-exportImg-ozWHO`,
	"profileViewlabel": `WhyHostFormBlock6-profileViewlabel-iT7Ld`,
	"profileViewMainContent": `WhyHostFormBlock6-profileViewMainContent-WJ9Wy`,
	"profileViewMain": `WhyHostFormBlock6-profileViewMain-Ywe8i`,
	"profileViewInner": `WhyHostFormBlock6-profileViewInner-lDwg_`,
	"profileImageSection": `WhyHostFormBlock6-profileImageSection-SGBjl`,
	"lastviewInner": `WhyHostFormBlock6-lastviewInner-il0Nf`,
	"whyHostHoriLine": `WhyHostFormBlock6-whyHostHoriLine-TvRkY`,
	"tableGrid": `WhyHostFormBlock6-tableGrid-j_efe`,
	"headingContent": `WhyHostFormBlock6-headingContent-umVc8`,
	"refundTextColor": `WhyHostFormBlock6-refundTextColor-cXBo1`,
	"dividerLine": `WhyHostFormBlock6-dividerLine-nrn0m`,
	"smallContent": `WhyHostFormBlock6-smallContent-uUmTZ`,
	"ChangeToUpperCase": `WhyHostFormBlock6-ChangeToUpperCase-LXtKN`,
	"noBorder": `WhyHostFormBlock6-noBorder-zqUDB`,
	"siteAdminHeading": `WhyHostFormBlock6-siteAdminHeading-jhpFi`,
	"siteAdminSubHeading": `WhyHostFormBlock6-siteAdminSubHeading-Uvv2X`,
	"adminFormDivider": `WhyHostFormBlock6-adminFormDivider-InGdX`,
	"errorMessage": `WhyHostFormBlock6-errorMessage-l65Kb`,
	"labelText": `WhyHostFormBlock6-labelText-OKeku`,
	"space1": `WhyHostFormBlock6-space1-S4jdU`,
	"space2": `WhyHostFormBlock6-space2-YBdLM`,
	"space3": `WhyHostFormBlock6-space3-VVMHo`,
	"space4": `WhyHostFormBlock6-space4-D3rzv`,
	"space5": `WhyHostFormBlock6-space5-JhLc5`,
	"space6": `WhyHostFormBlock6-space6-afjY1`,
	"space7": `WhyHostFormBlock6-space7-oFy5Y`,
	"spaceTop8": `WhyHostFormBlock6-spaceTop8-FmQHC`,
	"spaceTop1": `WhyHostFormBlock6-spaceTop1-MGGkT`,
	"spaceTop2": `WhyHostFormBlock6-spaceTop2-boGQR`,
	"spaceTop3": `WhyHostFormBlock6-spaceTop3-nV_iP`,
	"spaceTop4": `WhyHostFormBlock6-spaceTop4-JFkGm`,
	"spaceTop5": `WhyHostFormBlock6-spaceTop5-aHmVV`,
	"spaceTop6": `WhyHostFormBlock6-spaceTop6-LMlA1`,
	"spaceTop7": `WhyHostFormBlock6-spaceTop7-ViejD`,
	"padding1": `WhyHostFormBlock6-padding1-jrVou`,
	"padding2": `WhyHostFormBlock6-padding2-fgsui`,
	"padding3": `WhyHostFormBlock6-padding3-rDIV1`,
	"padding4": `WhyHostFormBlock6-padding4-JswGt`,
	"padding5": `WhyHostFormBlock6-padding5-c90_J`,
	"padding6": `WhyHostFormBlock6-padding6-wSAex`,
	"padding7": `WhyHostFormBlock6-padding7-rhSCJ`,
	"paddingTop1": `WhyHostFormBlock6-paddingTop1-u3V8G`,
	"paddingTop2": `WhyHostFormBlock6-paddingTop2-WgwBY`,
	"paddingTop3": `WhyHostFormBlock6-paddingTop3-qHqX5`,
	"paddingTop4": `WhyHostFormBlock6-paddingTop4-qo2U4`,
	"paddingTop5": `WhyHostFormBlock6-paddingTop5-jKYO6`,
	"paddingTop6": `WhyHostFormBlock6-paddingTop6-j8WBU`,
	"paddingTop7": `WhyHostFormBlock6-paddingTop7-Rfpwd`,
	"noPadding": `WhyHostFormBlock6-noPadding-B0IuZ`,
	"textBold": `WhyHostFormBlock6-textBold-RwOln`,
	"textBolder": `WhyHostFormBlock6-textBolder-SZAT1`,
	"textNormal": `WhyHostFormBlock6-textNormal-I09uA`,
	"spaceBottom20": `WhyHostFormBlock6-spaceBottom20-kSw56`,
	"spaceBottom10": `WhyHostFormBlock6-spaceBottom10-PDHRs`,
	"marginNone": `WhyHostFormBlock6-marginNone-Rz0jp`,
	"spaceBottom15": `WhyHostFormBlock6-spaceBottom15-Z9cV2`,
	"marginTopNone": `WhyHostFormBlock6-marginTopNone-yqBVx`,
	"spaceTop11": `WhyHostFormBlock6-spaceTop11-cIRe2`,
	"spaceTop21": `WhyHostFormBlock6-spaceTop21-rJKoA`,
	"spaceTop20": `WhyHostFormBlock6-spaceTop20-Aj1Pi`,
	"spaceTop10": `WhyHostFormBlock6-spaceTop10-U3t45`,
	"textDarkBlue": `WhyHostFormBlock6-textDarkBlue-weMNd`,
	"textLightBlue": `WhyHostFormBlock6-textLightBlue-qXKZf`,
	"textLightSandleGreen": `WhyHostFormBlock6-textLightSandleGreen-eA7pw`,
	"textLightBrown": `WhyHostFormBlock6-textLightBrown-sJZSq`,
	"textMediumMaroon": `WhyHostFormBlock6-textMediumMaroon-svSCX`,
	"textBrown": `WhyHostFormBlock6-textBrown-BUoMP`,
	"textMaroon": `WhyHostFormBlock6-textMaroon-IJllk`,
	"textDarkBrown": `WhyHostFormBlock6-textDarkBrown-sdLzl`,
	"textMediumBrown": `WhyHostFormBlock6-textMediumBrown-spxCb`,
	"textSkyBlue": `WhyHostFormBlock6-textSkyBlue-W02pi`,
	"textGray": `WhyHostFormBlock6-textGray-Bx_k1`
};
module.exports = ___CSS_LOADER_EXPORT___;
